<script setup lang="ts">
import { CREDIT_REASONS } from '../content';
import { CreditSectionTitle } from '../CreditSectionTitle';
</script>

<template>
	<section
		class="border-t border-[#1F1F1F] bg-[#0D0D0D] px-6 py-26 text-[#FAFAFA]"
	>
		<div class="mx-auto max-w-[1240px]">
			<CreditSectionTitle class="max-w-[760px]">
				Por que fazer seu crédito com a Pilar
			</CreditSectionTitle>
			<div
				class="mt-13 grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-x-8 gap-y-10"
			>
				<div
					v-for="reason in CREDIT_REASONS"
					:key="reason.title"
					class="flex flex-col gap-3 border-t border-[#4A4A4A] pt-5.5"
				>
					<div class="text-[19px] font-medium">{{ reason.title }}</div>
					<div class="text-[15px] leading-[1.6] text-[#C9C9C9]">
						{{ reason.description }}
					</div>
				</div>
			</div>
		</div>
	</section>
</template>
